export const CATEGORIES = [
  {
    id: "content",
    icon: "Edit3",
    name: "Content Services",
    desc: "Build, shape, edit, translate, or produce video/course content",
    subtypes: [
      "Content build", "Content shaping", "Content editing", "Content translation / localisation",
      "Video build", "Video editing", "Captioning", "Microskilling course build",
      "Deal Ready Accelerator build", "Simulated lab build",
    ],
    fields: [
      { id: "c_solution", label: "Solution area / product focus", type: "text", placeholder: "e.g. Copilot for Sales" },
      { id: "c_source", label: "Source material status", type: "select", opts: ["Needs creation from scratch", "Partial source exists", "Full source exists, needs adaptation"] },
      { id: "c_coursetype", label: "Target course type", type: "select", opts: ["Sales Ready", "Tech Deal Ready", "Project Ready", "Microskilling", "Deal Ready Accelerator", "Other"] },
      { id: "c_volume", label: "Volume", type: "text", placeholder: "e.g. 6 modules, ~40 min each" },
      { id: "c_languages", label: "Languages required", type: "text", placeholder: "Leave blank if English only" },
      { id: "c_labs", label: "Lab requirement", type: "select", opts: ["None", "Simulated", "Live"] },
      { id: "c_platform", label: "Target platform", type: "select", opts: ["LevelUp", "Digital Catalog", "Skilling Hub", "Undecided \u2014 platform team to triage"] },
      { id: "c_journey", label: "Belongs to an existing journey/programme?", type: "text", placeholder: "Name it, or write 'Net new'" },
    ],
  },
  {
    id: "delivery",
    icon: "GraduationCap",
    name: "Training Delivery",
    desc: "In-person, live online, on-demand builds, assessments, badges",
    subtypes: [
      "In-person training delivery", "Live online \u2014 private 1:1", "Live online \u2014 multi-partner 1:many",
      "On-demand LMS course build (SCORM)", "Content ingestion into LMS", "Assessment build",
      "Badge integration", "Learning journey build", "Private program build (self-paced)",
    ],
    fields: [
      { id: "d_location", label: "Delivery location(s)", type: "text", placeholder: "If in-person; leave blank otherwise" },
      { id: "d_audience", label: "Expected audience size", type: "text" },
      { id: "d_sessions", label: "Number of sessions / cohorts", type: "text" },
      { id: "d_assessment", label: "Assessment required?", type: "select", opts: ["No", "Yes \u2014 pass/fail", "Yes \u2014 scored"] },
      { id: "d_badge", label: "Badge / credential required?", type: "select", opts: ["No", "Yes \u2014 Credly", "Yes \u2014 other"] },
      { id: "d_labs", label: "Lab requirement", type: "select", opts: ["None", "Simulated", "Live"] },
      { id: "d_platform", label: "Target platform", type: "select", opts: ["LevelUp", "LMS direct", "Skilling Hub", "Undecided \u2014 platform team to triage"] },
      { id: "d_dates", label: "Preferred delivery date(s)", type: "text" },
    ],
  },
  {
    id: "program",
    icon: "Megaphone",
    name: "Programme / Campaign",
    desc: "New partner, customer, or employee programme or campaign",
    subtypes: ["New partner programme", "New customer programme", "New employee programme", "Recruitment / enablement campaign"],
    fields: [
      { id: "p_sponsor", label: "Sponsoring team / stakeholder", type: "text" },
      { id: "p_audience", label: "Target audience segment", type: "select", opts: ["Partner", "Customer", "Employee", "Reseller", "Other"] },
      { id: "p_content", label: "Content approach", type: "select", opts: ["Reuse existing LevelUp content", "New content needed", "Mixed"] },
      { id: "p_hosting", label: "Hosting preference", type: "select", opts: ["Skilling Hub", "LevelUp", "Undecided \u2014 platform team to triage"] },
      { id: "p_duration", label: "Programme / campaign duration", type: "text", placeholder: "e.g. Ongoing, or Q3 FY27 only" },
      { id: "p_metrics", label: "Success metrics expected", type: "text" },
    ],
  },
  {
    id: "event",
    icon: "Calendar",
    name: "Live Event Setup",
    desc: "Registration pages, promotion, hosting, and reporting (Cvent)",
    subtypes: ["Branded registration page", "Registration promotion / driving sign-ups", "Registration & attendance reporting", "Live virtual event hosting", "Post-event reporting"],
    fields: [
      { id: "e_format", label: "Event format", type: "select", opts: ["Virtual", "Hybrid", "In-person"] },
      { id: "e_volume", label: "Expected registrant volume", type: "text" },
      { id: "e_branding", label: "Branding assets available?", type: "select", opts: ["Yes", "No \u2014 need support producing them"] },
      { id: "e_dates", label: "Event date(s)", type: "text" },
      { id: "e_reporting", label: "Reporting cadence needed", type: "text", placeholder: "e.g. daily registration count, post-event summary" },
    ],
  },
  {
    id: "platform",
    icon: "Link2",
    name: "Net-New Platform",
    desc: "A new standalone system \u2014 precedent: Compete Hub, SIAB, My Goals, Digital Catalog",
    subtypes: ["New standalone platform / application", "Major extension of an existing platform"],
    fields: [
      { id: "n_problem", label: "Problem statement \u2014 why can't an existing system serve this?", type: "textarea" },
      { id: "n_userbase", label: "Expected user base / scale", type: "text" },
      { id: "n_integration", label: "Integration / SSO needs", type: "text", placeholder: "e.g. SSO from LevelUp, data feed to X" },
      { id: "n_hosting", label: "Hosting preference / constraints", type: "text" },
      { id: "n_support", label: "Ownership & ongoing support model expected", type: "text" },
      { id: "n_pii", label: "Data / PII considerations", type: "text" },
      { id: "n_precedent", label: "Closest existing precedent", type: "select", opts: ["Compete Hub", "Skilling in a Box", "My Goals", "Digital Catalog", "None of these"] },
    ],
  },
];

export const DEPENDENCIES = ["LevelUp", "Skilling Hub", "Cypher LMS", "MAQ / Enablement Insights Cube", "SCORM Cloud", "Digital Catalog", "Cvent", "Compete Hub", "Skilling in a Box", "My Goals", "Other"];
